import { render, staticRenderFns } from "./FeedbackDetail.vue?vue&type=template&id=24500f7a&scoped=true"
import script from "./FeedbackDetail.ts?vue&type=script&lang=ts&external"
export * from "./FeedbackDetail.ts?vue&type=script&lang=ts&external"
import style0 from "./FeedbackDetail.vue?vue&type=style&index=0&id=24500f7a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24500f7a",
  null
  
)

export default component.exports